import axiosInstance from "../../services/axios";
import axios from "../../services/axios";
import { Card } from "./paymentsType/Card";

interface GetAllParams {
  query : any;
  }

const PaymentService = {
    getAll: async ({query}: GetAllParams) => {
        try {
        const res = await axios.get(`/payment/payment-methods?${query}`);
            return {
              data: res.data
            };
          } catch (error) {
            console.error("Error fetching cards:", error);
            throw error;
          }
        },

        create: async (payload: any) => {
          try {
            const response = await axios.post(
              `/payment/link-payment-method`,
              payload
            );
            return response.data;
          } catch (error) {
            console.error("Error creating card:", error);
            throw error;
          }
        },

        createStripeId: async (payload: any) => {
          try {
            const response = await axiosInstance.post(
              `/payment/customer`,
              payload
            );
            // console.log('responserrr', response.data)
            return response.data;
           
          } catch (error) {
            console.error("Error creating stripe customer id:", error);
            throw error;
          }
        },

        delete: async (paymentMethodId: string) => {
          try {
            const response = await axios.delete( `/payment/detachpayment?paymentmethod=${paymentMethodId}`);
            return response.data;
          } catch (error) {
            console.error("Error deleting card:", error);
            throw error;
          }
        },
      };
      
        
export default PaymentService